import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/planificacion-estrategica")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/planificacion-estrategica", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia", replace: true });
  },
});
